import { render } from "./ClienteCrear.vue?vue&type=template&id=d674dfe4"
import script from "./ClienteCrear.vue?vue&type=script&lang=js"
export * from "./ClienteCrear.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__